import { EFindingType } from '@enums/campaign-analytics.enum';

export interface IManualFindingStatus {
  id: string;
  campaignId: string;
  creatorId: string;
  deliverableId: string;
  parentId: string;
  status: EManualFindingStatus | null;
  socialContentId: string;
  findingType: EFindingType;
  findingId: string;
  processed: boolean;
}

export interface ICreateManualFindingStatusPayload {
  campaignId: string;
  creatorId: string;
  deliverableId: string;
  parentId: string;
  socialContentId: string;
  findingType: EFindingType;
  findingId: string;
}

export interface IGetManualFindingStatusParams {
  campaignId?: string;
  creatorId?: string;
  deliverableId?: string;
  parentId?: string;
  socialContentId?: string;
  findingType?: EFindingType;
  findingId?: string;
  processed?: boolean;
}

export interface IPendingManualFindingStatus extends ICreateManualFindingStatusPayload {
  visualizerId: string;
  keyword: string;
  keywordId: string;
}

export enum EManualFindingStatus {
  removed = 'removed',
}
